<script setup>
import { setToken } from '@/lib/user';
import { useRoute } from 'vue-router';
const route = useRoute();

if (route.query.token) {
  setToken(route.query.token);
  window.location.href = '/';
}
</script>

<template>
  <div class="overflow-y-scroll h-full"></div>
</template>
